export default __webpack_public_path__ + "static/media/part2_a1_m.436620b3.png";